import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/index',
    name: 'indexView',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/me',
    name: 'me',
    component: () => import('../views/me/me.vue')
  },
  {
    path: '/device/:id',
    name: 'deviceView',
    component: () => import('../views/index/device.vue')
  },
  {
    path: '/ops',
    name: 'opsView',
    component: () => import('../views/index/ops.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
